// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function join(x) {
  return Stdlib_Option.getOr(x, undefined);
}

function sequence(options) {
  return Stdlib_Array.reduce(options, [], (maybeAcc, opt) => Stdlib_Option.flatMap(maybeAcc, acc => Stdlib_Option.map(opt, x => acc.concat([x]))));
}

function sequence2(opts) {
  let val1 = opts[0];
  if (val1 === undefined) {
    return;
  }
  let val2 = opts[1];
  if (val2 !== undefined) {
    return [
      Primitive_option.valFromOption(val1),
      Primitive_option.valFromOption(val2)
    ];
  }
}

function sequence3(opts) {
  let val1 = opts[0];
  if (val1 === undefined) {
    return;
  }
  let val2 = opts[1];
  if (val2 === undefined) {
    return;
  }
  let val3 = opts[2];
  if (val3 !== undefined) {
    return [
      Primitive_option.valFromOption(val1),
      Primitive_option.valFromOption(val2),
      Primitive_option.valFromOption(val3)
    ];
  }
}

function sequence4(opts) {
  let val1 = opts[0];
  if (val1 === undefined) {
    return;
  }
  let val2 = opts[1];
  if (val2 === undefined) {
    return;
  }
  let val3 = opts[2];
  if (val3 === undefined) {
    return;
  }
  let val4 = opts[3];
  if (val4 !== undefined) {
    return [
      Primitive_option.valFromOption(val1),
      Primitive_option.valFromOption(val2),
      Primitive_option.valFromOption(val3),
      Primitive_option.valFromOption(val4)
    ];
  }
}

function okOr(opt, err) {
  if (opt !== undefined) {
    return {
      TAG: "Ok",
      _0: Primitive_option.valFromOption(opt)
    };
  } else {
    return {
      TAG: "Error",
      _0: err
    };
  }
}

function orElse(opt, f) {
  if (opt !== undefined) {
    return opt;
  } else {
    return f();
  }
}

function tryMap(x, f) {
  return Stdlib_Option.getOr(f(x), x);
}

function forNone(x, f) {
  if (x !== undefined) {
    return Primitive_option.some(Primitive_option.valFromOption(x));
  } else {
    f();
    return;
  }
}

function toArray(opt) {
  if (opt !== undefined) {
    return [Primitive_option.valFromOption(opt)];
  } else {
    return [];
  }
}

function unionWith(f, mbX, mbY) {
  if (mbX !== undefined) {
    if (mbY !== undefined) {
      return Primitive_option.some(f(Primitive_option.valFromOption(mbX), Primitive_option.valFromOption(mbY)));
    } else if (mbY !== undefined) {
      return mbY;
    } else {
      return mbX;
    }
  } else if (mbY !== undefined) {
    return mbY;
  } else {
    return mbX;
  }
}

export {
  join,
  sequence,
  sequence2,
  sequence3,
  sequence4,
  okOr,
  orElse,
  tryMap,
  forNone,
  toArray,
  unionWith,
}
/* No side effect */
